module.exports = __webpack_public_path__ + "static/media/default-shop-logo.5bfdf40a.svg";